export { default as component } from "../../../../src/routes/[prefix]/(feature)/activity-approval-real/+page.svelte";